import { ReactComponent as Chevron } from "assets/icons/chevron.svg";
import Button from "./button";
import { twMerge } from "tailwind-merge";

const ButtonWithChevron = ({ className = "", children, ...rest }) => {
  return (
    <Button variant="primary" className={twMerge("p-2", className)} {...rest}>
      <span className="pl-[42px] pr-[12px] text-lg">{children}</span>
      <span className="w-[52px] h-[52px] bg-white/10 rounded-full flex justify-center items-center rotate-90">
        <Chevron stroke="#fff" />
      </span>
    </Button>
  );
};
export default ButtonWithChevron;
